import React from 'react';
import FontFaceObserver from 'fontfaceobserver';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { App } from 'containers';
import RouteTracker from 'components/RouteTracker'; 
import ScrollToTop from 'components/ScrollToTop/ScrollToTop'; 
import { createStoreWeb } from 'coupon-common';
import { translationMessages } from './i18n';

import 'theme/global-styles.scss';

const dest = document.getElementById('root');
const store = createStoreWeb();
const notoSansObserver = new FontFaceObserver('Noto Sans', {});

notoSansObserver.load().then(() => {
  document.body.classList.add('fonts--loaded');
});

const root = ReactDOM.createRoot(dest);

function render(messages) {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <RouteTracker /> 
        <ScrollToTop />
        <App messages={messages} />
      </BrowserRouter>
    </Provider>,
  );
}

if (module.hot) {
  module.hot.accept(['./i18n', './containers/App/App'], () => {
    render(translationMessages);
  });
}

if (!window.IntersectionObserver) {
  require('intersection-observer');
}

if (!window.Intl) {
  new Promise(resolve => {
    resolve(import('intl'));
  })
    .then(() =>
      Promise.all([
        import('intl/locale-data/jsonp/en.js'),
        import('intl/locale-data/jsonp/de.js'),
      ]),
    )
    .then(() => render(translationMessages))
    .catch(err => {
      throw err;
    });
} else {
  render(translationMessages);
}